import { useState } from "react";
import axios from "axios";
import { CheckCircle } from "@phosphor-icons/react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function Tap2VerifyPublic() {
  const [form, setForm] = useState({
    brand: "",
    seller_or_listing: "",
    location_or_url: "",
    country_code: "IN",
    description: "",
    reporter_name: "",
    reporter_email: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(null);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true); setErr(null);
    try {
      const r = await axios.post(`${BASE}/api/public/tap2verify`, form);
      setDone(r.data);
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Submission failed");
    } finally { setSubmitting(false); }
  };

  if (done) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--span-surface-2)]">
        <div className="card-flat p-8 max-w-md text-center" data-testid="t2v-public-done">
          <CheckCircle size={36} weight="duotone" className="text-emerald-600 mx-auto mb-3"/>
          <div className="font-display font-bold text-xl mb-2">Thank you</div>
          <div className="text-[13px] text-[var(--span-text-2)]">
            Your report was logged. SPAN curators will review and may follow up at the email you provided.
          </div>
          <div className="text-[10px] font-mono text-[var(--span-text-2)] mt-4">Ref: {done.verification_id}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[var(--span-surface-2)] flex items-center justify-center p-6">
      <div className="card-flat p-6 max-w-lg w-full" data-testid="t2v-public-form">
          <img src="/api/static/brand/C2_Horizontal_White.svg" alt="SPAN CasePrime" className="h-8 mb-3" style={{ width: "200px", height: "auto" }}/>
        <div className="label-eyebrow">Tap2Verify · Public report</div>
        <h1 className="font-display font-bold text-2xl mt-1 mb-1">Spotted a counterfeit?</h1>
        <p className="text-[12px] text-[var(--span-text-2)] mb-4">
          Report suspicious products or sellers. SPAN curators will verify high-value reports for the Field Marketplace.
        </p>
        <form onSubmit={submit} className="space-y-3 text-[12px]">
          <Input label="Brand being faked *" value={form.brand} onChange={v => setForm({ ...form, brand: v })} required testid="t2v-brand"/>
          <Input label="Seller / listing / shop *" value={form.seller_or_listing} onChange={v => setForm({ ...form, seller_or_listing: v })} required testid="t2v-seller"/>
          <Input label="Location or URL" value={form.location_or_url} onChange={v => setForm({ ...form, location_or_url: v })} testid="t2v-url"/>
          <div className="grid grid-cols-2 gap-2">
            <Input label="Country" value={form.country_code} onChange={v => setForm({ ...form, country_code: v.toUpperCase() })} testid="t2v-country"/>
            <Input label="Your name" value={form.reporter_name} onChange={v => setForm({ ...form, reporter_name: v })} testid="t2v-name"/>
          </div>
          <Input label="Your email (optional)" value={form.reporter_email} onChange={v => setForm({ ...form, reporter_email: v })} type="email" testid="t2v-email"/>
          <div>
            <label className="block label-eyebrow mb-1">What did you see? *</label>
            <textarea data-testid="t2v-description" required rows={4} value={form.description}
                      onChange={e => setForm({ ...form, description: e.target.value })}
                      className="w-full hairline px-2 py-1.5 surface"/>
          </div>
          {err && <div className="text-red-600 text-[11px]">{err}</div>}
          <button data-testid="t2v-submit" type="submit" disabled={submitting}
                  className="btn-primary px-4 py-2 text-[12px] w-full">
            {submitting ? "Submitting…" : "Submit report"}
          </button>
          <div className="text-[10px] text-[var(--span-text-2)] text-center">
            By submitting, you confirm the information is accurate to the best of your knowledge.
          </div>
        </form>
      </div>
    </div>
  );
}

function Input({ label, value, onChange, type = "text", required, testid }) {
  return (
    <div>
      <label className="block label-eyebrow mb-1">{label}</label>
      <input data-testid={testid} type={type} required={required} value={value}
             onChange={e => onChange(e.target.value)}
             className="w-full hairline px-2 py-1.5 surface"/>
    </div>
  );
}
